import React, { useEffect, useState } from "react";
import axios from "axios";
import { X } from "lucide-react";

const ProductFilterModal = ({ close, filters, setFilters }: any) => {
  const [products, setProducts] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const fetchProducts = async (p = 1) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/produk`, {
        params: { page: p },
      });

      setProducts(res.data.data);
      setPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      {/* MODAL */}
      <div className="bg-white rounded-2xl w-[650px] shadow-2xl">
        {/* HEADER */}
        <div className="flex justify-between items-center border-b p-4">
          <h2 className="font-bold text-lg">Pilih Produk</h2>

          <button onClick={close} className="p-1 rounded hover:bg-gray-100">
            <X size={20} />
          </button>
        </div>

        {/* PRODUCT LIST */}
        <div className="p-4 space-y-3 max-h-[400px] overflow-y-auto">
          {products.map((p) => (
            <div
              key={p.id}
              onClick={() => {
                setFilters({ ...filters, product_id: p.id });
                close();
              }}
              className="flex items-center gap-4 p-3 border rounded-xl cursor-pointer hover:bg-gray-50 hover:shadow transition">
              {/* IMAGE */}
              <img src={`${process.env.REACT_APP_STORAGE_URL}/products/${p.images?.[0]?.image}`} alt={p.name} className="w-14 h-14 object-cover rounded-lg border" onError={(e: any) => (e.target.src = "/no-image.png")} />

              {/* INFO */}
              <div className="flex-1">
                <p className="font-semibold">{p.name}</p>
                {p.price && <p className="text-sm text-gray-500">Rp {p.price.toLocaleString()}</p>}
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION */}
        <div className="flex justify-between items-center border-t p-4">
          <button disabled={page === 1} onClick={() => fetchProducts(page - 1)} className="px-3 py-1 border rounded disabled:opacity-40">
            Prev
          </button>

          <span className="text-sm text-gray-500">
            Page {page} / {lastPage}
          </span>

          <button disabled={page === lastPage} onClick={() => fetchProducts(page + 1)} className="px-3 py-1 border rounded disabled:opacity-40">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductFilterModal;
